import Seo from "../components/Seo";
import Section from "../components/ui-custom/Section";
import ServicesGrid from "../components/sections/ServicesGrid";
import CTA from "../components/sections/CTA";
import PageHeader from "../components/ui-custom/PageHeader";

export default function Services() {
  return (
    <>
      <Seo title="Services" description="Explore all utipanagecy digital services — PAN, UTI PSA, NSDL, ITR, Recharge, BBPS, AEPS, Banking, White Label and API." />
      <PageHeader eyebrow="Services" title="Every digital service, one platform" sub="Tap any service to view features, eligibility, documents and pricing." />
      <Section testId="services-page">
        <ServicesGrid withFilter />
      </Section>
      <CTA />
    </>
  );
}
